var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.theLabel,"label-for":_vm.id}},[_c('b-form-input',_vm._g(_vm._b({attrs:{"id":_vm.id,"state":_vm.hasError,"autofocus":_vm.autofocus,"value":_vm.value}},'b-form-input',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),(!!_vm.help)?_c('small',{class:_vm.helpVariant},[_vm._v(_vm._s(_vm.help))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }